import { useTranslations } from '@vocab/react';
import { Box, Stack, Text, TextLink } from 'braid-design-system';
import type { FC } from 'react';

import { useAppConfig } from 'src/constants/AppConfig/AppConfigProvider';
import { CactusIllustration } from 'src/libs/Illustrations';

import translations from './.vocab';

export const VerificationsEmptyState: FC = () => {
  const { t } = useTranslations(translations);
  const { router, locale, site } = useAppConfig();
  return (
    <Box display="flex" justifyContent="center">
      <Box maxWidth="small" data={{ testid: 'verifications-empty' }}>
        <Stack space="small" align="center">
          <CactusIllustration width={128} height={128} />
          <Text weight="strong">{t('No verified credentials')}</Text>
          <Text>
            {t(
              "This applicant doesn't have any credentials verified by <Link>SEEK Pass</Link>.",
              {
                Link: (children) => (
                  <TextLink
                    href={router.seekPassFindOutMore({ locale, site })}
                    target="_blank"
                  >
                    {children}
                  </TextLink>
                ),
              },
            )}
          </Text>
        </Stack>
      </Box>
    </Box>
  );
};
